import { constants, typographyStyles } from "@newsela/angelou";
import { gradientBackgrounds } from "@/components/AIComponents/AiComponents.style";

const { colors } = constants;
const { fontSize } = typographyStyles;
const neutral600 = colors.ui.neutral[600];
const neutral700 = colors.ui.neutral[500];
const black = colors.ui.black[700];
const { textMObj } = typographyStyles;

export const loadingCss = {
  borderRadius: "8px",
  backgroundColor: "#eee",
  marginTop: "1em",
  padding: "1.5em 1em",
  textAlign: "center",
};

export const headerCss = {
  display: "flex",
  marginTop: "2em",
  alignItems: "center",
  justifyContent: "space-between",
};

export const headingCss = {
  color: neutral600,
  ...fontSize.heading5,
  fontWeight: "bold",
  margin: "0",
};

export const disclaimerCss = {
  marginTop: "1em",
  color: neutral700,
  ...fontSize.textS,
};

export const generatedPromptCss = {
  ...textMObj,
  marginTop: "0.5em",
  textAlign: "left",
  background: gradientBackgrounds[200],
  color: black,
  border: "none",
};

export const promptActionsContainerCss = {
  display: "flex",
  gap: 8,
  marginTop: 16,
};
